import { Recording } from '@streem/sdk-core';
import { useState } from 'react';

import { isPreviewReady, isRecordingPending, isRecordingReady } from '../util/artifacts';
import { isChrome } from '../util/is_chrome';
import { useGlobalStore } from './use_global_context';
import { useTranscriptionContext } from './use_transcription_context';

interface UseCallRecording {
    isAdmin: boolean;
    somePreviewsReady: boolean;
    showVideoPreviewInfoCard: boolean;
    setShowVideoPreviewInfoCard: (show: boolean) => void;
    videoPreviewTermsAccepted: boolean;
    setVideoPreviewTermsAccepted: (accepted: boolean) => void;
    browserCanPlayPreview: boolean;
    someRecordingsPending: boolean;
    someRecordingsReady: boolean;
    showVideoPreview: boolean;
    timeUpdateHandler: (event: Event) => void;
}

export function useCallRecording(
    recordings: Recording[],
    previewEnabled?: boolean,
): UseCallRecording {
    const { authStore } = useGlobalStore();
    const somePreviewsReady = isPreviewReady(recordings);
    const [showVideoPreviewInfoCard, setShowVideoPreviewInfoCard] = useState(false);
    const [videoPreviewTermsAccepted, setVideoPreviewTermsAccepted] = useState(false);
    const browserCanPlayPreview = isChrome();
    const someRecordingsPending = isRecordingPending(recordings);
    const someRecordingsReady = isRecordingReady(recordings);
    const showVideoPreview =
        previewEnabled && videoPreviewTermsAccepted && somePreviewsReady && !someRecordingsReady;
    const { timeUpdateHandler } = useTranscriptionContext();

    return {
        isAdmin: authStore.isAdmin,
        somePreviewsReady,
        showVideoPreviewInfoCard,
        setShowVideoPreviewInfoCard,
        videoPreviewTermsAccepted,
        setVideoPreviewTermsAccepted,
        browserCanPlayPreview,
        someRecordingsPending,
        someRecordingsReady,
        showVideoPreview,
        timeUpdateHandler,
    };
}
